( function ( _s ) {
	_s( document ).ready( () => {
		const appHeight = () => {
			window.setRootProperty( '--app-height', parseInt( window.innerHeight ) + 'px' );
		};

		_s( window ).on( 'resize', () => {
			appHeight();
		} );

		appHeight();
	} );
} )( window._s );
